import React from 'react';
import { Container as SemanticContainer } from 'semantic-ui-react';
import {
  Header,
  Segment,
  SegmentGroup,
  GridRow,
  GridColumn,
  Grid,
  Card,
  Image,
  Icon,
  Label,
  List,
  ListItem,
} from 'semantic-ui-react';
import { DefaultView } from '@plone/volto/components';
import config from '@plone/volto/registry';
import { flattenToAppURL } from '@plone/volto/helpers';

const PersonView = (props) => {
  const { content } = props;
  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;
  return (
    <>
      <Container id="page-document" className="default" textAlign="justified">
        <div className="default">
          <h2></h2>
          <Segment padded>
            <Grid columns={2} stackable>
              <GridRow>
                <GridColumn width={3}>
                  <Image
                    src={flattenToAppURL(
                      content.image?.scales?.preview?.download,
                    )}
                    size="small"
                    floated="left"
                    alt={content.userid}
                    rounded
                  />
                </GridColumn>
                <GridColumn>
                  <Header as="h2">{content.title}</Header>
                  <p>{content.designation}</p>
                  <p>
                    <strong>
                      <Icon name="mail" color="black" />
                    </strong>
                    {content.userid} [at] tifrbng [dot] res [dot] in
                  </p>
                  <p>
                    <strong>Phone :</strong> {content.contact_number}
                  </p>
                  <p>
                    <strong>Website :</strong>{' '}
                    <a
                      href={content.website}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {content.website}
                    </a>
                  </p>
                </GridColumn>
              </GridRow>
            </Grid>
          </Segment>

          <div>
            {content.biography && content.research_interest && (
              <Segment padded>
                <Header as="h3">Research Interests</Header>
                <ul>
                  {content.research_interest?.map((item) => {
                    return <li>{item.token}</li>;
                  })}
                </ul>
              </Segment>
            )}

            {content.short_bio && (
              <Segment padded>
                <div
                  dangerouslySetInnerHTML={{
                    __html: props.content.short_bio.data,
                  }}
                />
              </Segment>
            )}

            {content.biography && (
              <Segment Padded>
                <Header as="h3">About {content.first_name}</Header>
                <div
                  dangerouslySetInnerHTML={{
                    __html: props.content.biography.data,
                  }}
                />
              </Segment>
            )}

            {content.description && (
              <p className="documentDescription">{content.description}</p>
            )}
          </div>
        </div>
        {/*
		<div className="default">
		    <h2> Card Test </h2>
		    <Segment>
			<Grid divided columns={2} stackable >
			    <GridRow>
				<GridColumn width={6}>
				    <Image
					src={flattenToAppURL(content.image?.scales?.preview?.download)}
					size="small"
					floated='left'
					alt={content.userid}
					rounded
				    />
				    <Header as='h3'>{content.title}</Header>
				    <p>{content.designation}</p>		    
				    <p><strong>Email:</strong >{content.userid} [at] tifrbng [dot] res [dot] in</p>
				    <p><strong>Contact Number:</strong> {content.contact_number}</p>				     
				</GridColumn>
				<GridColumn width={4}>
				    <Header as='h3'>Research Interests</Header>
				    <List>
				    {content.research_interest?.map((item) => {
					return (
					    <ListItem>{item.token}</ListItem>
					);
				    })}
				    </List>
				    <p></p>
				    <p><a href={content.website} target="_blank" rel="noopener noreferrer">Website</a></p>
				</GridColumn>
			    </GridRow>
			</Grid>
		    </Segment>

		</div>
		*/}
      </Container>
    </>
  );
};

export default PersonView;
